module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-stone-path-background.a0f78db2.png";